// Pagination.jsx
import styles from "./Pagination.module.css";
import { Right, left } from "../../controller/Images";

const Pagination = ({
  currentPage,
  rowsPerPage,
  totalItems, // totalItems will now be passed as the length of the filtered/processed data
  rowsPerPageOptions = [10, 20, 50],
  onPageChange,
  onRowsPerPageChange,
}) => {
  // Ensure inputs are numbers for calculations
  const safeCurrentPage = Number(currentPage) || 1;
  const safeRowsPerPage = Number(rowsPerPage) || 10;
  const safeTotalItems = Number(totalItems) || 0;

  const totalPages = Math.ceil(safeTotalItems / safeRowsPerPage);

  const handlePrevious = () => {
    if (safeCurrentPage > 1) {
      onPageChange(safeCurrentPage - 1);
    }
  };

  const handleNext = () => {
    if (safeCurrentPage < totalPages) {
      onPageChange(safeCurrentPage + 1);
    }
  };

  const handleRowsChange = (e) => {
    onRowsPerPageChange(Number(e.target.value));
    onPageChange(1); // Always reset to the first page when rows per page changes
  };

  const start =
    safeTotalItems === 0 ? 0 : (safeCurrentPage - 1) * safeRowsPerPage + 1;
  const end = Math.min(start + safeRowsPerPage - 1, safeTotalItems);

  // Determine if buttons should be disabled
  const isPreviousDisabled = safeCurrentPage === 1 || safeTotalItems === 0;
  const isNextDisabled = safeCurrentPage === totalPages || safeTotalItems === 0;

  return (
  <div className={styles.container}>
  <div className={styles.rowWrapper}>
    <span>Rows per page:</span>
    <select
      value={safeRowsPerPage}
      onChange={handleRowsChange}
      className={styles.select}
    >
      {rowsPerPageOptions.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>

  <div className={styles.paginationControls}>
    <button
      onClick={handlePrevious}
      disabled={isPreviousDisabled}
      className={`${styles.button} ${
        isPreviousDisabled ? styles.disabled : ""
      }`}
    >
      <img
        src={left}
        alt="Prev"
        style={{
          width: "16px",
          height: "16px",
          opacity: isPreviousDisabled ? 0.4 : 1,
          cursor: isPreviousDisabled ? "not-allowed" : "pointer",
        }}
      />
    </button>

    <span className={styles.text}>
      {safeTotalItems === 0
        ? "0 - 0 of 0"
        : `${start} - ${end} of ${safeTotalItems}`}
    </span>

    <button
      onClick={handleNext}
      disabled={isNextDisabled}
      className={`${styles.button} ${isNextDisabled ? styles.disabled : ""}`}
    >
      <img
        src={Right}
        alt="Next"
        style={{
          width: "16px",
          height: "16px",
          opacity: isNextDisabled ? 0.4 : 1,
          cursor: isNextDisabled ? "not-allowed" : "pointer",
        }}
      />
    </button>
  </div>
</div>

  );
};

export default Pagination;
